<script>
export default {
  name: "Index",
  methods: {
    jump() {
      window.location = "weixin://dl/business/?appid=wx39b303a6898a065b&path=pages/index/index"
    }
  },
  created() {
    this.jump()
  }
}
</script>

<template>
  <div class="container">
    <img class="title" src="@/assets/img/title.png" alt="智能云服务">
    <van-button type="info" size="large" round @click="jump">跳转小程序</van-button>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 100px 10px 10px;
}

.title {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 10px 30px;
  background: #1a7fef;
}
</style>
